<template>
  <v-card class="card" color="primary">
    <v-card-title class="d-flex justify-space-between">
      <div class="text-h5 font-weight-bold">Referencias</div>
      <TextButton small @click="downloadPDF">
        <v-icon left small>mdi-download</v-icon>
        Descargar PDF
      </TextButton>
    </v-card-title>
    <v-card-text>
      <ReporteReferenciasComponent
        ref="reporteReferencias"
        :referencias="allReferencias"
        :nombrePersonal="getFullName(personal)"
        :personal="personal"
      />
      <v-tabs v-model="selectedTab" color="secondary" fixed-tabs>
        <v-tab class="font-weight-bold">Vecinal</v-tab>
        <v-tab class="font-weight-bold">Personal</v-tab>
        <v-tab class="font-weight-bold">Laboral</v-tab>
      </v-tabs>
      <v-tabs-items v-model="selectedTab" class="transparent">
        <v-tab-item :key="REFERENCIAS_TABS.VECINAL">
          <v-container>
            <v-row>
              <v-col cols="12">
                <ReferenciasTable
                  :referencias="referenciasVecinal"
                  type="vecinal"
                  @edit="openEditReferencia"
                  @delete="handleDeleteReferencia"
                />
              </v-col>
              <v-col cols="12" class="text-center">
                <TextButton
                  v-if="referenciasVecinal.length < MAX_LIMIT_REFERENCIAS"
                  color="secondary"
                  @click="openNuevaReferencia"
                >
                  Agregar referencia
                </TextButton>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item :key="REFERENCIAS_TABS.PERSONAL">
          <v-container>
            <v-row>
              <v-col cols="12">
                <ReferenciasTable
                  :referencias="referenciasPersonales"
                  type="personal"
                  @edit="openEditReferencia"
                  @delete="handleDeleteReferencia"
                />
              </v-col>
              <v-col cols="12" class="text-center">
                <TextButton
                  v-if="referenciasPersonales.length < MAX_LIMIT_REFERENCIAS"
                  color="secondary"
                  @click="openNuevaReferenciaFamiliar"
                >
                  Agregar referencia personal
                </TextButton>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item :key="REFERENCIAS_TABS.LABORAL">
          <v-container>
            <v-row>
              <v-col cols="12">
                <ReferenciasTable
                  :referencias="referenciasLaborales"
                  type="laboral"
                  @edit="openEditReferencia"
                  @delete="handleDeleteReferencia"
                />
              </v-col>
              <v-col cols="12" class="text-center">
                <TextButton
                  v-if="referenciasLaborales.length < MAX_LIMIT_REFERENCIAS"
                  color="secondary"
                  @click="openNuevaReferenciaLaboral"
                >
                  Agregar referencia laboral
                </TextButton>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { DIALOG_TYPES } from '../../plugins/dialog-types'
import TextButton from '../base/TextButton.vue'
import ReferenciasTable from '../referencias/ReferenciasTable.vue'
import ReporteReferenciasComponent from './ReporteReferenciasComponent.vue'

const REFERENCIAS_TABS = {
  VECINAL: 0,
  PERSONAL: 1,
  LABORAL: 2,
}
const MAX_LIMIT_REFERENCIAS = 3

export default {
  components: {
    TextButton,
    ReporteReferenciasComponent,
    ReferenciasTable,
  },

  props: {
    personal: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      selectedTab: REFERENCIAS_TABS.VECINAL,
      DIALOG_TYPES,
      REFERENCIAS_TABS,
      MAX_LIMIT_REFERENCIAS,
      referenciaToDelete: null,
    }
  },

  created() {
    this.fetchReferenciasByPersonal(this.personal.idPersonal)
  },

  computed: {
    ...mapGetters('referenciaEnlaceC3', {
      referenciasVecinal: 'getReferenciaVecinal',
      referenciasLaborales: 'getReferenciasLaborales',
      referenciasPersonales: 'getReferenciasPersonales',
    }),

    allReferencias() {
      return [...this.referenciasVecinal, ...this.referenciasPersonales, ...this.referenciasLaborales]
    },
  },

  methods: {
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapActions('referenciaEnlaceC3', ['fetchReferenciasByPersonal']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    downloadPDF() {
      this.$refs.reporteReferencias.generateReport()
    },

    getFullName(person) {
      if (!person) return ''
      if (person.segundoNombre == '') {
        return person.apaterno + ' ' + person.amaterno + ' ' + person.nombre
      } else {
        return person.apaterno + ' ' + person.amaterno + ' ' + person.nombre + ' ' + person.segundoNombre
      }
    },

    handleDeleteReferencia(referencia) {
      this.referenciaToDelete = referencia
      this.SET_DIALOG({
        ...DIALOG_TYPES.CONFIRMACION_ELIMINAR_REFERENCIA,
        props: {
          onConfirm: this.confirmDelete,
        },
      })
    },
    async confirmDelete() {
      if (!this.referenciaToDelete) return

      try {
        await this.$store.dispatch('referenciaEnlaceC3/deleteReferencia', {
          idPersonal: this.personal.idPersonal,
          idReferencia: this.referenciaToDelete.id,
        })
        await this.fetchReferenciasByPersonal(this.personal.idPersonal)

        this.SET_SNACKBAR_MESSAGE('Referencia eliminada correctamente')
        this.referenciaToDelete = null
        this.$store.dispatch('dialog/closeDialog')
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Error al eliminar la referencia')
        console.error('Error al eliminar:', error)
        this.$store.dispatch('dialog/closeDialog')
      }
    },

    openNuevaReferencia() {
      this.SET_DIALOG({
        ...DIALOG_TYPES.REGISTRAR_NUEVA_REFERENCIA,
        props: {
          idPersonal: this.personal.idPersonal,
        },
      })
    },

    openNuevaReferenciaFamiliar() {
      this.SET_DIALOG({
        ...DIALOG_TYPES.REGISTRAR_NUEVA_REFERENCIA_PERSONAL,
        props: {
          idPersonal: this.personal.idPersonal,
        },
      })
    },

    openNuevaReferenciaLaboral() {
      this.SET_DIALOG({
        ...DIALOG_TYPES.REGISTRAR_NUEVA_REFERENCIA_LABORAL,
        props: {
          idPersonal: this.personal.idPersonal,
        },
      })
    },

    openEditReferencia(referencia) {
      if (this.selectedTab === REFERENCIAS_TABS.PERSONAL) {
        this.SET_DIALOG({
          ...DIALOG_TYPES.REGISTRAR_NUEVA_REFERENCIA_PERSONAL,
          props: {
            idPersonal: this.personal.idPersonal,
            referencia,
          },
        })
      }

      if (this.selectedTab === REFERENCIAS_TABS.LABORAL) {
        this.SET_DIALOG({
          ...DIALOG_TYPES.REGISTRAR_NUEVA_REFERENCIA_LABORAL,
          props: {
            idPersonal: this.personal.idPersonal,
            referenciaToUpdate: referencia,
          },
        })
      }

      if (this.selectedTab === REFERENCIAS_TABS.VECINAL) {
        this.SET_DIALOG({
          ...DIALOG_TYPES.REGISTRAR_NUEVA_REFERENCIA,
          props: {
            idPersonal: this.personal.idPersonal,
            referenciaToUpdate: referencia,
          },
        })
      }
    },
  },
}
</script>

<style scoped>
.card-header {
  width: 640px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
